/* SEO под регионы (апекс / Беларусь / Казахстан).
   Landing вызывает useSeo с этими данными, react-snap пререндерит
   /, /by, /kz как отдельные HTML с региональными title/description,
   canonical и перекрёстными hreflang. */

const SITE = 'https://amorika.love';
const OG_IMAGE = `${SITE}/landing/hero-bg.webp`;

/* Кластер hreflang — один и тот же на всех трёх страницах.
   Со слэшем в конце — как canonical остальных SEO-страниц и sitemap. */
export const HREFLANG_ALTERNATES = [
  { hreflang: 'ru',        href: `${SITE}/` },
  { hreflang: 'ru-BY',     href: `${SITE}/by/` },
  { hreflang: 'ru-KZ',     href: `${SITE}/kz/` },
  { hreflang: 'x-default', href: `${SITE}/` },
];

function graph(canonical, description) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': 'Organization', name: 'Amorika', url: `${SITE}/`, logo: `${SITE}/logo-amorika.png` },
      { '@type': 'WebSite', name: 'Amorika', url: canonical, inLanguage: 'ru', description },
    ],
  };
}

const RU = {
  title: 'Сайт-приглашение на свадьбу — сделать за 5 минут · Amorika',
  description: 'Сделайте сайт-приглашение на свадьбу за 5 минут: красивые фото, дата, карта проезда и онлайн-подтверждение присутствия гостей. 16+ шаблонов, отправка в Telegram, MAX, СМС и email.',
  canonical: `${SITE}/`,
  heroNote: null,
};

const BY = {
  title: 'Свадебное приглашение онлайн в Беларуси — конструктор сайтов · Amorika',
  description: 'Электронное приглашение на свадьбу в Беларуси за 5 минут: красивый сайт с вашими фото, датой, картой проезда и онлайн-подтверждением присутствия гостей. 16+ шаблонов, отправка в Telegram, Viber, email.',
  canonical: `${SITE}/by/`,
  heroNote: 'Беларусь',
};

const KZ = {
  title: 'Свадебное приглашение онлайн в Казахстане — конструктор сайтов · Amorika',
  description: 'Электронное приглашение на свадьбу (шақыру) в Казахстане за 5 минут: красивый сайт с вашими фото, датой, картой проезда и онлайн-подтверждением присутствия гостей. 16+ шаблонов, отправка в WhatsApp, Telegram, email.',
  canonical: `${SITE}/kz/`,
  heroNote: 'Казахстан',
};

const MAP = { ru: RU, by: BY, kz: KZ };

/* Возвращает готовый объект для useSeo по региону. */
export function regionSeo(region) {
  const r = MAP[region] || RU;
  return {
    title: r.title,
    description: r.description,
    canonical: r.canonical,
    image: OG_IMAGE,
    alternates: HREFLANG_ALTERNATES,
    jsonLd: graph(r.canonical, r.description),
    heroNote: r.heroNote,
  };
}
